import { useTracking } from '@repo/tracking/use-tracking';
import { Trans, useTranslation } from '@repo/translations/use-translation';
import { lazy, Suspense } from 'react';

import { Anchor } from '@zooplus/ui-components';

const BenefitIcon1 = lazy(() => import('./benefit-1.svg'));
const BenefitIcon2 = lazy(() => import('./benefit-2.svg'));
const BenefitIcon3 = lazy(() => import('./benefit-3.svg'));
import styles from './ProgramBenefitsAdvertisement.module.css';

export const ProgramBenefitsAdvertisement = () => {
  const { t } = useTranslation();
  const { trackClick } = useTracking();

  return (
    <ul className={styles.benefits} data-testid="program-benefits-advertisement">
      <li className={styles.box}>
        <Suspense fallback={null}>
          <BenefitIcon1 className={styles.icon} aria-hidden />
        </Suspense>
        <div className={styles.benefit}>
          <h2 className={styles.title}>
            {t('loyalty-program.public-landing-page.benefits-advertisement.benefit1.title')}
          </h2>
          <p className={styles.description}>
            {t('loyalty-program.public-landing-page.benefits-advertisement.benefit1.description')}
          </p>
        </div>
      </li>
      <li className={styles.box}>
        <Suspense fallback={null}>
          <BenefitIcon2 className={styles.icon} aria-hidden />
        </Suspense>
        <div className={styles.benefit}>
          <h2 className={styles.title}>
            {t('loyalty-program.public-landing-page.benefits-advertisement.benefit2.title')}
          </h2>
          <p className={styles.description}>
            <Trans
              i18nKey={
                'loyalty-program.public-landing-page.benefits-advertisement.benefit2.description'
              }
              components={{
                LinkRewards: (
                  <Anchor
                    href="/bonuspoints/products"
                    onClick={() => {
                      trackClick({
                        target: {
                          name: 'benefits_summary',
                          id: 'reward_shop_link',
                        },
                      });
                    }}
                  />
                ),
              }}
            />
          </p>
        </div>
      </li>
      <li className={styles.box}>
        <Suspense fallback={null}>
          <BenefitIcon3 className={styles.icon} aria-hidden />
        </Suspense>
        <div className={styles.benefit}>
          <span className={styles.premiumBadge}>
            <Trans
              i18nKey={'loyalty-program.public-landing-page.benefits-advertisement.premium-badge'}
            />
          </span>
          <h2 className={styles.title}>
            {t('loyalty-program.public-landing-page.benefits-advertisement.benefit3.title')}
          </h2>
          <p className={styles.description}>
            {t('loyalty-program.public-landing-page.benefits-advertisement.benefit3.description')}
          </p>
        </div>
      </li>
    </ul>
  );
};
